module.exports = __webpack_public_path__ + "img/aqxj.26df3320.svg";